import RestError from '../app/errors';

export default class BadPhoneNumberError extends RestError {}

export class VerificationConflictError extends RestError {}
